var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import styled from 'styled-components';
import { thousandSeparator, padNumber } from '../../utils/utils';
import { Table, TableHead, TableBody, TableRow, TableHeader, TableCell, } from '@bootstraplabs/bsw-common-react';
var TableHeaderWithIndent = styled(TableHeader)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding-left: ", ";\n"], ["\n  padding-left: ", ";\n"])), function (props) { return (props.indent ? '32px' : null); });
var TableWithDefaultCursor = styled(Table)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  cursor: default;\n"], ["\n  cursor: default;\n"])));
function isOptionGrant(security) {
    return !!security.optionPlan;
}
export function getRemainingPool(props) {
    var totalOptionPlanSize = props.optionPlans.reduce(function (acc, val) {
        return acc + val.planSize;
    }, 0);
    var totalShares = props.securities.reduce(function (acc, val) {
        return acc + (isOptionGrant(val) ? 0 : val.quantity);
    }, 0);
    // The total shares + options (issued and remaining pool)
    var totalQuantity = totalOptionPlanSize + totalShares;
    var getIssuedOptionCount = function (optionPlanId) {
        return props.securities.reduce(function (acc, val) {
            return (acc +
                (isOptionGrant(val) && val.optionPlan.id === optionPlanId
                    ? val.quantity
                    : 0));
        }, 0);
    };
    var remainingPool = props.optionPlans.reduce(function (acc, val) {
        var remainingOptions = val.planSize - getIssuedOptionCount(val.id);
        var ownership = (remainingOptions / totalQuantity) * 100;
        return acc + ownership;
    }, 0);
    return remainingPool;
}
export default function CapTableComponentUI(props) {
    var _a = useState(null), selectedId = _a[0], setSelectedId = _a[1];
    var totalOptionPlanSize = props.optionPlans.reduce(function (acc, val) {
        return acc + val.planSize;
    }, 0);
    var totalShares = props.securities.reduce(function (acc, val) {
        return acc + (isOptionGrant(val) ? 0 : val.quantity);
    }, 0);
    // The total shares + options (issued and remaining pool)
    var totalQuantity = totalOptionPlanSize + totalShares;
    var getIssuedOptionCount = function (optionPlanId) {
        return props.securities.reduce(function (acc, val) {
            return (acc +
                (isOptionGrant(val) && val.optionPlan.id === optionPlanId
                    ? val.quantity
                    : 0));
        }, 0);
    };
    // Arrange data
    var securityRows = props.securities.reduce(function (acc, val) {
        var _a, _b;
        var _c, _d;
        var stakeholderId = val.stakeholder.id;
        var stakeholderName = val.stakeholder.name;
        var isSelected = stakeholderId === selectedId;
        var security = {
            id: val.id,
            name: isOptionGrant(val) ? val.optionPlan.name : val.shareClass.name,
            quantity: val.quantity,
            ownership: (val.quantity / totalQuantity) * 100,
            nested: true,
            handleClick: function () { return null; },
        };
        var stakeholder = {
            id: stakeholderId,
            name: stakeholderName,
            quantity: security.quantity + (((_c = acc[stakeholderId]) === null || _c === void 0 ? void 0 : _c.quantity) || 0),
            ownership: security.ownership + (((_d = acc[stakeholderId]) === null || _d === void 0 ? void 0 : _d.ownership) || 0),
            nested: false,
            handleClick: function () { return setSelectedId(!isSelected ? stakeholderId : null); },
        };
        return __assign(__assign(__assign({}, acc), (_a = {}, _a[stakeholderId] = stakeholder, _a)), (isSelected && (_b = {}, _b[val.id] = security, _b)));
    }, {});
    var optionRows = props.optionPlans.reduce(function (acc, val) {
        var _a, _b;
        var _c, _d;
        var remainingPoolId = 'total-remaining-pool';
        var remainingPoolName = 'Remaining pool';
        var isSelected = remainingPoolId === selectedId;
        var remainingOptions = val.planSize - getIssuedOptionCount(val.id);
        var optionPlan = {
            id: val.id,
            name: val.name,
            quantity: remainingOptions,
            ownership: (remainingOptions / totalQuantity) * 100,
            nested: true,
            handleClick: function () { return null; },
        };
        var remainingPool = {
            id: remainingPoolId,
            name: remainingPoolName,
            quantity: optionPlan.quantity + (((_c = acc[remainingPoolId]) === null || _c === void 0 ? void 0 : _c.quantity) || 0),
            ownership: optionPlan.ownership + (((_d = acc[remainingPoolId]) === null || _d === void 0 ? void 0 : _d.ownership) || 0),
            nested: false,
            handleClick: function () { return setSelectedId(!isSelected ? remainingPoolId : null); },
        };
        return __assign(__assign(__assign({}, acc), (_a = {}, _a[remainingPoolId] = remainingPool, _a)), (isSelected ? (_b = {}, _b[val.id] = optionPlan, _b) : {}));
    }, {});
    var allRows = __assign(__assign({}, securityRows), optionRows);
    return (_jsxs(TableWithDefaultCursor, __assign({ nowrap: true }, { children: [_jsx(TableHead, { children: _jsxs(TableRow, { children: [_jsx(TableHeader, __assign({ align: "left" }, { children: "Stakeholder" }), void 0),
                        _jsx(TableHeader, __assign({ align: "right" }, { children: "Fully diluted" }), void 0),
                        _jsx(TableHeader, __assign({ align: "right" }, { children: "Ownership" }), void 0)] }, void 0) }, void 0),
            _jsx(TableBody, { children: Object.values(allRows).map(function (row) { return (_jsxs(TableRow, __assign({ onClick: row.handleClick }, { children: [_jsx(TableHeaderWithIndent, __assign({ nowrap: false, indent: row.nested ? true : false, align: "left" }, { children: row.name }), void 0),
                        _jsx(TableCell, __assign({ align: "right" }, { children: thousandSeparator(row.quantity) }), void 0),
                        _jsxs(TableCell, __assign({ align: "right" }, { children: [padNumber(row.ownership), "%"] }), void 0)] }), row.id)); }) }, void 0)] }), void 0));
}
var templateObject_1, templateObject_2;
//# sourceMappingURL=CapTableComponentUI.js.map